<template>
	<div class="detail-wrap">
		<el-form ref="editForm" :model="role">
			<div class="d-header clearfix">
				<div class="fl">
					<i class="el-icon-info" />
					{{ dataId ? '查看' : '新增' }}用户角色
				</div>
				<div class="fr">
					<el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置</el-button>
					<el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
				</div>
			</div>
			<div class="d-cont">
				<div class="d-item">
					<div class="title first"><b>基本信息</b></div>
					<table class="table-detail">
						<tbody>
							<tr>
								<th>
									<em class="f-red">*</em>
									用户角色
								</th>
								<td>
									<el-form-item prop="name" :rules="[{ required: true, trigger: 'blur' }]">
										<el-input type="text" autocomplete="off" v-model="role.name" clearable />
									</el-form-item>
								</td>
								<th>角色描述</th>
								<td>
									<el-form-item prop="description" :rules="[{ required: false, trigger: 'blur' }]">
										<el-input type="text" autocomplete="off" v-model="role.description" clearable />
									</el-form-item>
								</td>
							</tr>
							<tr>
								<th>创建人</th>
								<td>{{ role.createBy }}</td>
								<th>创建时间</th>
								<td>{{ role.createDate }}</td>
								<th>更新人</th>
								<td>{{ role.modifyBy }}</td>
								<th>更新时间</th>
								<td>{{ role.modifyDate }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="d-item">
					<div class="title"><b>菜单信息</b></div>
					<div class="role-box">
						<div class="item" v-for="item in allMenus" :class="{ hide: item.visibleRole }">
							<div class="t">
								{{ item.menuName }}
								<i class="el-icon-arrow-down fr" @click="$set(item, 'visibleRole', !item.visibleRole)"></i>
							</div>
							<div class="c">
								<div v-for="subItem in item.children">
									<div class="c-2nd"><el-checkbox :label="subItem.menuName" v-model="subItem.hasAuth" @change="selectAll(subItem)"></el-checkbox></div>
									<div class="c-3rd">
										<div class="c-item" v-for="(thrItem, index3) in subItem.children">
											<div class="name">
												<el-checkbox :label="thrItem.menuName" v-model="thrItem.hasAuth" @change="cancelSelect(subItem, index3)"></el-checkbox>
											</div>
											<div class="c-4th">
												<el-checkbox
													v-for="(fourthItem, index4) in thrItem.children"
													:label="fourthItem.menuName"
													v-model="fourthItem.hasAuth"
													@change="changeBtnSelect(subItem, index3, index4)"
												></el-checkbox>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-form>
	</div>
</template>

<script>
export default {
	name: 'roleEdit',
	props: ['_dataId'],
	components: {},
	data() {
		return {
			tabIndex: 0,
			isEdit: false,
			dataId: '',
			role: {
				menus: [],
				isSystem: false
			},
			allMenus: [],
			showCompanyDialog: false,
			cParam: { selectMulti: false }
		};
	},
	created() {
		if (this._dataId) this.dataId = this._dataId;
	},
	async mounted() {
		var that = this;
		this.getData();
	},
	methods: {
		async getData() {
			await this.initMenuData();
			if (this.dataId) {
				this.isEdit = true;
				this.$http({
					url: USER_PREFIX + `/role/get`,
					method: `post`,
					data: {
						id: this.dataId
					},
					isLoading: true,
					modalStrictly: true,
					success: res => {
						this.role = res.objx || {};
						let menuIds = this.handleRoles(this.allMenus, this.role.menuIds || []);
						this.$forceUpdate();
					}
				});
			}
		},
		saveData() {
			this.$refs.editForm.validate(valid => {
				if (valid) {
					this.$baseConfirm('您确定要保存吗？').then(() => {
						var url = USER_PREFIX + (this.isEdit ? `/role/update` : `/role/save`);
						let formData = this.role;
						formData.menuIds = this.getMenuFormData();

						this.$http({
							url: url,
							method: `post`,
							data: formData,
							isLoading: true,
							success: res => {
								this.$message({
									message: res.content,
									type: 'success',
									duration: 500,
									onClose: t => {
										if (this.isEdit) {
											this.$baseReload();
										} else {
											this.$baseReload({
												updateParam: {
													_dataId: res.objx
												}
											});
										}
									}
								});
							}
						});
					});
				}
			});
		},
		initMenuData() {
			return this.$http({
				url: USER_PREFIX + '/menu/getAll',
				method: 'POST',
				isLoading: true,
				modalStrictly: true,
				success: res => {
					let menus = res.objx || [];
					this.allMenus = menus;
					this.$forceUpdate();
				}
			});
		},
		selectAll(subItem) {
			//subItem.hasAuth = !subItem.hasAuth;
			let res = subItem.hasAuth;
			if (subItem.children) {
				subItem.children.forEach(function(thrItem) {
					thrItem.hasAuth = res;
					if (thrItem.children) {
						thrItem.children.forEach(function(fourthItem) {
							fourthItem.hasAuth = res;
						});
					}
				});
			}
			this.$forceUpdate();
		},
		cancelSelect(subItem, index3) {
			let citem = subItem.children[index3];
			// citem.hasAuth = !citem.hasAuth;
			let res = citem.hasAuth;
			let isCheckSubItem = false;
			subItem.children.forEach(function(thrItem) {
				if (thrItem.hasAuth) {
					isCheckSubItem = true;
				}
			});
			subItem.hasAuth = isCheckSubItem;
			if (citem.children) {
				citem.children.forEach(function(fourthItem) {
					fourthItem.hasAuth = res;
				});
			}
			this.$forceUpdate();
		},
		changeBtnSelect(subItem, index3, index4) {
			let citem = subItem.children[index3].children[index4];
			// citem.hasAuth = !citem.hasAuth;
			let res = citem.hasAuth;
			let isCheckthrItem = false;
			subItem.children[index3].children.forEach(function(fourthItem) {
				if (fourthItem.hasAuth) {
					isCheckthrItem = true;
				}
			});

			let isCheckSubItem = false;
			subItem.children.forEach(function(thrItem) {
				if (thrItem.hasAuth) {
					isCheckSubItem = true;
				}
			});
			subItem.hasAuth = isCheckSubItem;
			this.$forceUpdate();
		},
		getMenuFormData() {
			let selectIds = [];
			let menus = this.allMenus;
			menus.forEach(function(item) {
				selectIds.push(item.id);
				if (item.children) {
					item.children.forEach(function(subItem) {
						if (subItem.hasAuth) {
							selectIds.push(subItem.id);
						}
						if (subItem.children) {
							subItem.children.forEach(function(thrItem) {
								if (thrItem.hasAuth) {
									selectIds.push(thrItem.id);
								}
								if (thrItem.children) {
									thrItem.children.forEach(function(fourthItem) {
										if (fourthItem.hasAuth) {
											selectIds.push(fourthItem.id);
										}
									});
								}
							});
						}
					});
				}
			});
			return selectIds;
		},
		handleRoles(rows, menuIds) {
			let newRows = [];
			for (let i = 0; i < rows.length; i++) {
				let row = rows[i];
				if (menuIds.includes(row.id)) {
					row.hasAuth = true;
				} else {
					row.hasAuth = false;
				}
				newRows.push(row);
				if (row.children) {
					let cRows = this.handleRoles(row.children, menuIds);
					if (cRows) {
						newRows = newRows.concat(cRows);
					}
				}
			}
			return newRows;
		}
	}
};
</script>
